// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2vrnr","content":"LoadingAlert_content__1Zc1b"};